import { render, staticRenderFns } from "./UsedSpaceTab.vue?vue&type=template&id=5f610675&"
import script from "./UsedSpaceTab.vue?vue&type=script&lang=js&"
export * from "./UsedSpaceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports